import React from "react";
import { Pin, PinOff } from "lucide-react";

export default function DataManagerOrdersColumnContextMenu({
  canFreezePanes = false,
  columnKey = "",
  columnLabel = "",
  hasFrozenPanes = false,
  isColumnFrozen = false,
  isOpen = false,
  onClose = null,
  onToggleColumnFreeze = null,
  onUnfreezePanes = null,
  position = null,
}) {
  const menuRef = React.useRef(null);

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (menuRef.current?.contains(event.target)) {
        return;
      }

      onClose?.();
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    document.addEventListener("pointerdown", handlePointerDown, true);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, true);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !position || !columnKey) {
    return null;
  }

  return (
    <div
      ref={menuRef}
      role="menu"
      aria-label={`Actions pour la colonne ${columnLabel}`}
      className="fixed z-[120] min-w-[15rem] overflow-hidden rounded-[4px] border border-slate-200/90 bg-white p-1 shadow-[0_18px_40px_rgba(15,23,42,0.16)]"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    >
      {canFreezePanes ? (
        <button
          type="button"
          role="menuitem"
          className="flex w-full items-center gap-2 rounded-[4px] px-2.5 py-2 text-left text-[12px] font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-50 hover:text-slate-950"
          onClick={() => {
            onToggleColumnFreeze?.(columnKey);
            onClose?.();
          }}
        >
          {isColumnFrozen ? (
            <PinOff className="shrink-0 text-slate-500" size={14} strokeWidth={2} />
          ) : (
            <Pin className="shrink-0 text-accent" size={14} strokeWidth={2} />
          )}
          <span>{isColumnFrozen ? "Dégeler cette colonne" : "Figer les volets"}</span>
        </button>
      ) : null}
      {hasFrozenPanes ? (
        <button
          type="button"
          role="menuitem"
          className="flex w-full items-center gap-2 rounded-[4px] px-2.5 py-2 text-left text-[12px] font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-50 hover:text-slate-950"
          onClick={() => {
            onUnfreezePanes?.();
            onClose?.();
          }}
        >
          <PinOff className="shrink-0 text-slate-500" size={14} strokeWidth={2} />
          <span>Dégeler tous les volets</span>
        </button>
      ) : null}
    </div>
  );
}
